import React from 'react';

import { styled } from 'styled-components';

import RichTextField from 'components/RichTextField/RichTextField';

interface RichTextFieldProps extends React.ComponentProps<typeof RichTextField> {}

const RichTextFieldWrapper: React.FC<RichTextFieldProps> = (props) => <RichTextField {...props} />;

const MenuItemSubHeader = styled(RichTextFieldWrapper)`
  p {
    font-size: 0.875rem;
    font-family: ${(props) => props.theme.fonts.default};
    margin-bottom: 0;
  }
`;

export default MenuItemSubHeader;
